<template>
  <div>
    <b-modal id="select-import-action" centered hide-footer>
      <template #modal-header="">
        <h5>Import File</h5>
        <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
      </template>
      <div class="button">
        <b-button @click="onShowSaleAdminAction" class="b-button" variant="outline-secondary"
          >Sale admin đã nhận bản giấy</b-button
        >
      </div>
      <div class="button">
        <b-button @click="onShowSendAccoutant" class="b-button" variant="outline-secondary"
          >Đã gửi bản giấy cho Kế toán</b-button
        >
      </div>
      <div class="button">
        <b-button @click="onShowAccountantReact" class="b-button" variant="outline-secondary"
          >Kế toán phản hồi nhận/ không nhận</b-button
        >
      </div>
    </b-modal>
    <modalSaleadminAction @closeModal="onHideSaleAdminConfirm"></modalSaleadminAction>
    <modalSendAccoutantAction @closeModal="onHideSendAccountant"></modalSendAccoutantAction>
    <modalAccountantReact @closeModal="onHideAccountantReact"></modalAccountantReact>
  </div>
</template>

<script>
  import modalAccountantReact from './modalAccountantReact.vue'
  import modalSendAccoutantAction from './modalSendAccoutantAction.vue'
  import modalSaleadminAction from './modalSaleadminAction.vue'
  export default {
    data() {
      return {}
    },
    components: { modalSaleadminAction, modalSendAccoutantAction, modalAccountantReact },
    methods: {
      onShowSaleAdminAction() {
        this.$bvModal.show('sale-admin-action')
        this.closeModal()
      },
      onHideSaleAdminConfirm() {
        this.$bvModal.hide('sale-admin-action')
      },
      onShowSendAccoutant() {
        this.$bvModal.show('send-accountant')
        this.closeModal()
      },
      onHideSendAccountant() {
        this.$bvModal.hide('send-accountant')
      },
      onShowAccountantReact() {
        this.$bvModal.show('accountant-react')
        this.closeModal()
      },
      onHideAccountantReact() {
        this.$bvModal.hide('accountant-react')
      },
      uploadStatusFile() {
        this.$emit('uploadStatusFile')
      },
      closeModal() {
        this.$emit('closeModal')
      },
    },
  }
</script>

<style scoped>
  .button {
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }
  .b-button {
    min-width: 250px;
  }
</style>
